import { useGetInsuranceDetails } from '@web-app/hooks/queries/insurance-details';

import { InsuranceV2UI } from './InsuranceV2UI';

type Props = {
  clientId: string;
};

/**
 * Connected component that fetches insurance data and passes it to the UI component.
 * Used in the "Insurance" tab of SidePane (via PatientSubTabs).
 */
export const InsuranceV2: React.FC<Props> = ({ clientId }) => {
  const {
    data: insuranceData,
    isPending: isInsuranceLoading,
    isError: isInsuranceError,
  } = useGetInsuranceDetails(clientId);

  return (
    <InsuranceV2UI
      clientId={clientId}
      insuranceData={insuranceData ?? null}
      isPending={isInsuranceLoading}
      isError={isInsuranceError}
    />
  );
};

InsuranceV2.displayName = 'InsuranceV2';
